import React, { useMemo } from 'react';

import SalesChannelsEdit from '@components/shared/sales_channels/SalesChannelsEdit';
import MerchantSelect from '@components/operator/MerchantSelect';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';

import { salesChannelService } from '@services/operator/salesChannelService';
import { shippingTypeService } from '@services/operator/shippingTypeService';

interface InventoryTypeOption {
  id: string;
  name?: string;
  [key: string]: unknown;
}

interface MerchantInventoryType {
  merchant_id: string;
  enabled?: boolean;
  inventory_type: InventoryTypeOption;
}

interface ShippingTypeOption {
  id: string;
  name?: string;
  code?: string;
  [key: string]: unknown;
}

// 新增模式：MerchantSelect 已強迫操作員選好 merchant，所以這裡不需要 useRecordMerchantSync。
// 只負責把 currentMerchant scope 的 reference data 注入 shared SalesChannelsEdit。
const SalesChannelsNewContent: React.FC = () => {
  const { merchantId, merchantInventoryTypes, merchantShippingTypes } = useOperatorData() as {
    merchantId: string | null;
    merchantInventoryTypes?: MerchantInventoryType[];
    merchantShippingTypes?: ShippingTypeOption[];
  };

  const inventoryTypes = useMemo<InventoryTypeOption[]>(() => {
    if (!merchantId) return [];
    return (merchantInventoryTypes ?? [])
      .filter(mit => mit.merchant_id === merchantId && mit.enabled !== false)
      .map(mit => mit.inventory_type)
      .filter(Boolean);
  }, [merchantInventoryTypes, merchantId]);

  const shippingTypes = useMemo<ShippingTypeOption[]>(
    () => (merchantShippingTypes ?? []) as ShippingTypeOption[],
    [merchantShippingTypes]
  );

  return (
    <SalesChannelsEdit
      role="operator"
      isNew={true}
      salesChannelService={salesChannelService}
      shippingTypeService={shippingTypeService}
      inventoryTypes={inventoryTypes}
      shippingTypes={shippingTypes}
      merchantIdForCreate={merchantId}
    />
  );
};

const OperatorSalesChannelsNew: React.FC = () => (
  <MerchantSelect>
    <SalesChannelsNewContent />
  </MerchantSelect>
);

export default OperatorSalesChannelsNew;
